import React from 'react'
import { Link } from 'react-router-dom'

function About() {
  return (
    <div>
    <div className="subheader normal-bg section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12 text-left">
            <h1 className="text-custom-white">About Us</h1>
            <ul className="custom-flex">
              <li className="fw-500"> <Link to="/" className="text-custom-white">Home</Link> </li>
              <li className="active fw-500"> About Us </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- End Subheader --> 
    <!-- Start About Us --> */}
    <section className="about-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="about-content">
              <h3><span className="text-custom-blue">About</span> Us </h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>
              <br/>
              <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
              <br/>
              <br/>
              <Link className="main-btn mt-25 m4" to="#">Learn More <i className="fas fa-arrow-right"></i></Link> </div>
          </div>
          <div className="col-lg-6">
            <div className="about-image clearfix">
              <div className="single-image float-left"> <img src="/tm/react/bycycle/assets/images/about-1.jpg" className="image-fit" alt="img"/> </div>
              <div className="single-image image-tow float-right"> <img src="/tm/react/bycycle/assets/images/about-2.jpg" className="image-fit" alt="img"/> </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <!-- End About Us --> 
    <!-- Start Our Team --> */}
    <div className="team-area team-all-seven bg-light-white">
      <div className="section-header text-center ">
        <div className="section-heading">
          <h3 className="text-custom-black">Our <span className="text-custom-blue">Team</span></h3>
          <div className="section-description">
            <p className="text-light-dark">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.</p>
          </div>
        </div>
      </div>
      <div className="team-warp">
        <div className="team-seven">
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/team-1.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Developer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/team-2.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Financer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/team-3.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Designer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/agent-4.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Developer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/team-4.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Market</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/agent-2.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Developer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/agent-3.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Financer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/agent-1.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Designer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/agent-5.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Developer</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="team-style-seven">
            <div className="imgBox-7"> <img src="/tm/react/bycycle/assets/images/agent-6.jpg" alt="img" className="full-width"/> </div>
            <div className="details-7">
              <div className="content-7">
                <h3>Member Name <br/>
                  <span>Market</span></h3>
                <ul>
                  <li><Link to="#"><i className="fab fa-facebook" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fa-brands fa-x-twitter"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-linkedin" aria-hidden="true"></i></Link></li>
                  <li><Link to="#"><i className="fab fa-google-plus" aria-hidden="true"></i></Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default About